import React from 'react'
// import StagesManager from '../components/StagesManager';
// import EmailManager from './EmailManager/emailmanager';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
// import Responsive from '../components/Responsive';

// import { nanoid } from 'nanoid';
// import DiagramEditor from '../components/views/DiagramEditor';
// import EmailAdminPerspective from './EmailManager/EmailAdminPerspective';
import { chooseFontColor } from '../utils/useful';
import HttpServices from '../utils/Http.services';
import { EmailFrames } from '../variables/AppletPages';
import CollectionBaseAdminView from './Applets/CollectionBaseAdminView';
import StagesManager from '../components/StagesManager';

class Email extends React.Component {
    state = {
        colors: {
            primaryColor: '#006EE5',
            secondaryColor: '#007aff',
            textColor: '#fff'
        },
        accounts: [],
        currentAccount: null,
        headerConfig: {
            showToolbar: true, showSettings: true, showSettings: true, showFrames: 'email', type: 'email', isPortal: this.props.isPortal, title: '{{lang}}Email',
        },
    }

    componentDidMount() {
        // this.init(true)
        this.init(() => {

            let accounts = this.state.accounts
            let data = {}
            data.applet = this.props.applet

            let framesSections = Object.values(EmailFrames.sections)
            let frames = Object.values(EmailFrames.pages)
            accounts.map((element) => {
                element.key = element._id
                element.section = 'emails'
                element.pageType = 'email'
                element.fetchUrl = 'getMailAccounts'
                element.addUrl = 'sendMail'
                element.editUrl = 'updateMail'
                element.removeUrl = 'deleteMail'
                element.postBody = { hub: "{{appletHub}}", applet: '{{appletId}}' }
                element.filter = { hub: "{{appletHub}}", applet: '{{appletId}}' }

                frames.push(element)
            })

            this.setState({ framesSections, frames })
        })

    }

    functionsHandler = (type, name, data, extra) => {
        if (this[name]) {
            this[name](data, extra)
        }

    }
    setCurrentAccount = (data, index) => {
        this.setState({ currentAccount: data })
    }
    componentDidUpdate(prevProps) {
        if (this.props.data != prevProps.data) {
            this.init()
        }
    }
    
    init = (cb) => {
        HttpServices.request('getMailAccounts', {}, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }

            let currentAccount = this.state.currentAccount
            let accounts = fetchResult.info ?? []
            if (!currentAccount) {
                currentAccount = fetchResult.info[0]
            }
            this.setState({ accounts, currentAccount }, () => {

                // this.AdminPerspective.forceUpdateHeader()
                if (cb) {

                    cb()
                }
            })
        })
    }

    addAccounts = (data, cb) => {
        HttpServices.request('addAccount', data, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            if (fetchResult.info) {
                let accounts = this.state.accounts
                accounts.push(fetchResult.info)
                this.setState({ accounts }, () => {
                    this.AdminPerspective.forceUpdateHeader()
                    console.log('done')
                    if (cb) {
                        cb()
                    }
                })
            }
        })
    }








    render() {


        let colors = this.state.colors ?? {}
        let applet = this.props.applet
        if (applet?.colorType == 'sameAsHub') {

        }

        if (applet?.colorType == "custom") {
            colors = applet?.colors
        }

        if (!colors?.textColor) {
            colors.textColor = '#fff'
        }

        let iconInvert = chooseFontColor(colors.textColor) == '#fff' ? true : false

        colors.iconInvert = iconInvert
        colors.background = `linear-gradient(90deg, ${colors.primaryColor}, ${colors.secondaryColor})`



        // console.log(colors)

        return (
            <div className='h-100 w-100'>
                {/* <EmailAdminPerspective ref={el => this.AdminPerspective = el} functionsHandler={this.functionsHandler} addAccounts={this.addAccounts} sendMail={this.sendMail} accounts={this.state.accounts} currentAccount={this.state.currentAccount} baseUrl={[...this.props.baseUrl]} isPortal={this.props.isPortal} frames={this.state.frames} framesSections={this.state.framesSections} colors={colors} language={this.props.language} width={this.props.width} height={this.props.height} lastSelected={this.props.lastSelected} variables={this.props.variables} windowData={this.props.windowData} route={this.props.route} applet={this.props.applet} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.props.goToHub} /> */}
                <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}  >
                    <CollectionBaseAdminView defaultHeaderConfig={this.state.headerConfig} updateUserSettings={this.props.updateUserSettings} userSettings={this.props.userSettings} stageName={'admin'} stage={1} isDesktop={this.props.isDesktop} isMobile={this.props.isMobile} permissions={this.props.permissions} baseUrl={[...this.props.baseUrl, 'admin']} frames={this.state.frames} framesSections={this.state.framesSections} colors={colors} language={this.props.language} width={this.props.width} height={this.props.height} lastSelected={this.props.lastSelected} variables={this.props.variables} windowData={this.props.windowData} route={this.props.route} applet={this.props.applet} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.props.goToHub} updateConnectionPermissions={this.props.updateConnectionPermissions} appletAccess={this.props.appletAccess} closeWindow={this.props.closeWindow} setData={this.setData} frameUpdateActions={this.props.frameUpdateActions} automations={this.props.automations} />
                </StagesManager>

            </div>
        )
    }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Email);
